import type { ReactNode } from 'react'
import css from './FormError.module.css'
import {TextSmall} from '../../../Text'

interface FormErrorProps {
    children?: ReactNode
}

const FormError = ({ children }: FormErrorProps) => {
    if (!children) return null
    return <TextSmall className={css.error}>{children}</TextSmall>
}

export default FormError
